import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {User} from "@/types/User.tsx";
import {getData, saveData} from "@/utils/localStorage.tsx";
import {clientKey} from "@/config/constants/StorageKeys.tsx";

export interface ClientInitialState {
    selectedClient: User | null;
}

const initialState: ClientInitialState = {
    selectedClient: getData<User>(clientKey) || null,
};

const clientSlice = createSlice({
    name: 'client',
    initialState: initialState,
    reducers: {
        selectClient: (state, action: PayloadAction<User | null>) => {
            state.selectedClient = action.payload;

            if(action.payload === null) {
                localStorage.removeItem(clientKey);
                return;
            }

            saveData(clientKey, action.payload);
        }
    }
});

export const { selectClient } = clientSlice.actions;
export default clientSlice;